export default class Fones {

    constructor(resource) {
        this._resource = resource('fones_supo');
    }

    save(rdados) {
        return this._resource
            .save({}, rdados)
            .then(res => res.json()
                , err => {
                    throw new Error(err.statusText)
                });
    }
}